<ng-content select="[~right]"></ng-content>

@if (visible$ | async) {
	<div
		#backdrop
		moveToRoot
		class="pos-abs pos-t-0 pos-l-0 bg-backdrop w-100 h-100 backdrop p-safe border-box fl fl-ai-c fl-jc-c"
		[class.menu-closing]="isClosing"
		animate.enter="anim-menu-enter-fade"
		style="z-index: 10"
		(click)="close()"
	>
		<div
			class="wrapper p-2 border-box br-2h fl fl-dir-c shadow-menu"
			[class.bg-280]="!lightBg"
			[class.bg-180]="lightBg"
			[class.h-100]="fullHeight"
			[style.width]="width"
			[style.min-height]="minHeight"
			(click)="$event.stopPropagation()"
		>
			<div class="w-100 fl-fixed fl fl-ai-c fl-jc-fs p-2-b">
				<div #left class="fl-fixed fl" [style.minWidth.px]="right?.clientWidth || 0">
					<ng-content select="[~left]"></ng-content>
				</div>
				<div
					class="fl-adaptable fl fl-ai-c fl-jc-c fs-xl fc-800 fw-bold ellipsis talign-c p-2-rl border-box fw-bold pos-rel w-100"
				>
					<ng-content select="[~title]"></ng-content>
				</div>
				<div #right class="fl-fixed fl" [style.minWidth.px]="left?.clientWidth || 0">
					<button uiNewButtonIcon class="fl fc-400" (click)="close()">
						<i class="icon-cross"></i>
					</button>
				</div>
			</div>
			<div class="ov-auto pos-rel fl fl-dir-c" style="flex-grow: 1">
				<ng-content></ng-content>
			</div>
			<ng-content select="[~footer]"></ng-content>
		</div>
	</div>
}
